module.exports = __webpack_public_path__ + "img/shape-loader-512b1a86def1326d2bbeeb31543af14d.gif";